import {Injectable} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {Observable} from 'rxjs';
import {getLanguageEnumByLanguageCode, LanguageEnum} from '@core/enums/language.enum';
import {CoreReducer} from '../../core/store';
import {AppState} from '@core/reducers';
import {Store} from '@ngrx/store';
import {ReadingContentTypeEnum} from '@core/enums/reading-content-type.enum';
import {ReadingSpeedEnum} from '@core/enums/reading-speed.enum';
import {TtsRestService} from '@core/modules/rest/text-to-speech/tts-rest.service';
import {KeycloakService} from 'keycloak-angular';
import {LoggedUserDataModel} from '@core/modules/rest/user/response/logged-user-data.model';
import {take} from 'rxjs/operators';
import {PubliclinkRestService} from '@core/modules/rest/publiclink/publiclink-rest.service';

@UntilDestroy()
@Injectable()
export class PlayAudioService {
    audio = new Audio();
    ttsUrl: string | undefined;
    loggedUserData$: Observable<LoggedUserDataModel> = this.store.select(CoreReducer.loggedUserDataSelector);

    constructor(private store: Store<AppState>, private ttsService: TtsRestService, private keycloak: KeycloakService,
                private publicService: PubliclinkRestService) {
    }

    readCommands(text: string): void {
        const audioMode = sessionStorage.getItem('audioMode');
        if (audioMode) {
            const pollyObject = {
                text,
                readingContentType: ReadingContentTypeEnum.COMMAND,
                readingSpeed: ReadingSpeedEnum.MEDIUM,
                readingLanguage: null
            };
            const selectedLanguage = getLanguageEnumByLanguageCode(localStorage.getItem('languageCode'));

            this.keycloak.isLoggedIn().then((logged: boolean) => {
                    if (logged) {
                        this.loggedUserData$
                            .pipe(
                                take(1),
                                untilDestroyed(this))
                            .subscribe((loggedUserData: LoggedUserDataModel) => {
                                const personalSettings = JSON.parse(loggedUserData.personalSettings);
                                pollyObject.readingLanguage = personalSettings ? personalSettings.language : selectedLanguage;
                                this.ttsService.getTTS(pollyObject).pipe(untilDestroyed(this)).subscribe((data: string) => {
                                    this.ttsUrl = data;
                                    if (this.ttsUrl) {
                                        this.audio.src = this.ttsUrl;
                                        this.audio.load();
                                        this.audio.play();
                                    }
                                });
                            });

                    } else {
                        pollyObject.readingLanguage = selectedLanguage;
                        this.publicService.getPublicTTS(pollyObject).pipe(untilDestroyed(this)).subscribe((data: string) => {
                            this.ttsUrl = data;
                            if (this.ttsUrl) {
                                this.audio.src = this.ttsUrl;
                                this.audio.load();
                                this.audio.play();
                            }
                        });
                    }

                }
            );
        }
    }

    convertTextToSpeech(text: string, readingSpeed: ReadingSpeedEnum, language: LanguageEnum): void {
        const pollyObject = {
            text,
            readingSpeed,
            readingLanguage: language,
            readingContentType: ReadingContentTypeEnum.TEXT
        };

        this.ttsService.getTTS(pollyObject).pipe(untilDestroyed(this)).subscribe((data: string) => {
            this.ttsUrl = data;
            if (this.ttsUrl) {
                this.audio.src = this.ttsUrl;
                this.playAudio();
            }
        });

    }

    playAudio(): void {
        this.audio.load();
        this.audio.play();
    }

    pauseAudio(): void {
        if (!this.audio.ended) {
            this.audio.pause();
        }
    }

}
